import { getFileTypeIcon } from "@/lib/utils";
export function DocMessage({
  fileType,
  fileUrl = "",
}: {
  fileType: string;
  fileUrl?: string;
}) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-surface-hover rounded-lg border border-surface-border">
      <img
        loading="lazy"
        src={getFileTypeIcon(fileType)}
        alt="Sent"
        className="object-contain h-5 w-5 rounded bg-surface"
      />
      <span className="text-xs text-text-secondary truncate max-w-48">{fileUrl}</span>
    </div>
  );
}

export function ContentMessage({
  message = "View Diagram",
  icon,
}: {
  message?: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-surface-hover hover:bg-surface-active cursor-pointer rounded-full transition-colors border border-surface-border">
      <span className="h-4 w-4 text-text-secondary [&>svg]:text-text-secondary">{icon}</span>
      <span className="text-xs text-text-primary font-medium">{message}</span>
    </div>
  );
}

export function AiThinking({ isLoading }: { isLoading: boolean }) {
  if (!isLoading) return null;
  return (
    <div className="max-w-xs px-4 py-2 rounded-2xl rounded-tl-sm break-words bg-surface-card border border-surface-border">
      <span className="animate-pulse text-text-secondary text-sm">Breeze.AI processing</span>
      <span className="text-text-secondary before:content-['.'] before:animate-dots" />
    </div>
  );
}
